import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    return localStorage.getItem("site-lang") || "fr";
  });

  useEffect(() => {
    const html = document.documentElement;
    html.lang = lang;
    html.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("site-lang", lang);
  }, [lang]);

  const t = useCallback(
    (path) => {
      const keys = path.split(".");
      let current = translations[lang];
      for (const k of keys) {
        if (current == null) return path;
        current = current[k];
      }
      return current ?? path;
    },
    [lang]
  );

  const toggleLang = useCallback(() => {
    setLang((l) => (l === "fr" ? "ar" : "fr"));
  }, []);

  const value = useMemo(
    () => ({ lang, setLang, toggleLang, t, isRTL: lang === "ar" }),
    [lang, toggleLang, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
